export * from './institute.slice';
export * from './institute.selectors';
